/**
 * Command-autocomplete dropdown state: a pure state container returning the
 * three pieces of dropdown state plus setters. Matching logic
 * (getMatchingCommands) stays in the orchestrator and drives these setters.
 */
import { useState } from 'react';
import type { CommandInfo } from '@/features/chat/utils/command-parser';

export interface UseCommandAutocompleteReturn {
  showCommandDropdown: boolean;
  setShowCommandDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  commandMatches: CommandInfo[];
  setCommandMatches: React.Dispatch<React.SetStateAction<CommandInfo[]>>;
  selectedCommandIndex: number;
  setSelectedCommandIndex: React.Dispatch<React.SetStateAction<number>>;
}

export function useCommandAutocomplete(): UseCommandAutocompleteReturn {
  const [showCommandDropdown, setShowCommandDropdown] = useState(false);
  const [commandMatches, setCommandMatches] = useState<CommandInfo[]>([]);
  const [selectedCommandIndex, setSelectedCommandIndex] = useState(0);

  return {
    showCommandDropdown,
    setShowCommandDropdown,
    commandMatches,
    setCommandMatches,
    selectedCommandIndex,
    setSelectedCommandIndex,
  };
}
